import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const CommonState = Immutable.fromJS({
	allGears: [],
	allFirefighterTypes: [],
});

const commonReducer = handleActions({
	FIND_ALL_GEARS: (state, { payload }) => {
		return state.merge({
			allGears: payload.data
		})
	},
	FIND_ALL_FIREFIGHTER_TYPES: (state, { payload }) => {
		return state.merge({
			allFirefighterTypes: payload.data
		})
	}
}, CommonState);

export default commonReducer;


// WEBPACK FOOTER //
// ./src/reducers/commonReducer.js